import autocomplete  from "devbridge-autocomplete/dist/jquery.autocomplete.min";

export default function () {

    let searchBtn = document.getElementsByClassName('header-search__btn');

    let searchForm = document.getElementsByClassName('header-search')[0];

    if (!searchBtn.length || !searchForm.length) return;

    Array.from(searchBtn).forEach(button => button.addEventListener('click', function(e){
        if(searchForm.classList.contains('is-opened')){
            searchForm.submit();
        }
        else {
            searchForm.classList.add('is-opened');
            setTimeout(function () {
                searchForm.getElementsByTagName('input')[0].focus();
            }, 500);
        }
        e.preventDefault();
    }));


    let searchClose = document.getElementsByClassName('header-search__close')[0];


    searchClose.addEventListener('click', function () {
        searchForm.classList.remove('is-opened');
    });


    document.body.addEventListener("click", function(e) {
        let elm = e.target;
        while (elm !== document.body) {
            if (/(?:^| )header-search(?:$| )/.test(elm.className)) {
                return;
            }
            elm = elm.parentNode;
        }
        searchForm.classList.remove('is-opened');
        searchForm.classList.remove('show-results');
    });


    let options = {
        dataType: 'json',
        serviceUrl: searchForm.getAttribute('data-autocomplete-url'),
        appendTo: $('.header-search'),
        minChars: 2,
        paramName: 'q',
        deferRequestBy: 10,
        onSelect: function (suggestion) {
            window.changePage(suggestion.data.link);
        },
        formatResult: function (suggestion, currentValue) {
            let regex = new RegExp(currentValue, 'gi');
            let result = suggestion.value.replace(regex, '<strong>'+currentValue+'</strong>');
            return `<a href="${suggestion.data.link}" class="autocomplete-suggestion__link"><span  class="autocomplete-suggestion__category">${suggestion.data.category}</span><span class="autocomplete-suggestion__name">${result}</span></a>`;
        },
        showNoSuggestionNotice: true,
        onSearchStart: function () {
            $('.header-search').addClass('is-loading')
        },
        noSuggestionNotice: 'По запросу нет совпадений',
        onSearchComplete: function () {
            $('.header-search').addClass('show-results');
            setTimeout(function () {
                $('.header-search').removeClass('is-loading')
            }, 300);
        },
        onHide: function () {
            $('.header-search').removeClass('show-results');
        }
    };

    let search = $('.header-search__input').autocomplete(options)

}
